// extracted by mini-css-extract-plugin
export var label = "label-module--label--db7ac";